import TextField from '@mui/material/TextField';
import styled from "styled-components";

let Container=styled.div`
 	display:flex;
	align-items:center;
	justify-content:space-between;
	width:10vw;
	margin:15px
`

export default function InputEditFlagReventa(props){
	let {codflag,label,setNuevosPrecios,nuevosPrecios,precio}=props;

	let handleChangePrice=(e)=>{
		let newValue=e.target.value;
		setNuevosPrecios({...nuevosPrecios,[label]:newValue})
	}
	return(
		<Container>
 			<img loading="lazy" width="20" alt="flag"
            	srcSet={`https://flagcdn.com/w40/${codflag}.png 2x`} 
               	src={`https://flagcdn.com/w20/${codflag}.png`} 
            />
 			<TextField  onChange={handleChangePrice} size="small" 
 				sx={{width:"7vw",minWidth:"60px"}} 
 				color={nuevosPrecios[label]===precio?"primary":"success"} focused 
 				label={label} defaultValue={nuevosPrecios[label]} />
 		</Container>


		)

}